// API Configuration
// For local development: http://localhost:3001
// For production: Set REACT_APP_API_URL environment variable

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default API_URL;
